module.exports = __webpack_public_path__ + "static/media/ICONS-ELECTRONICS_&_IT.e4ea0d02.svg";